import React, { memo, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router";
import { useForm } from "react-hook-form";

import {
  questionTypeConstants,
  archivedQuestionsConstants,
} from "../../constants";
import {
  useSpinner,
  Spinner,
  archiveQuestionConfirmationModal,
  handleAsyncAction,
} from "../../../../shared";
import { archivedQuestionsActions } from "../../redux/actions";
import TextBox from "../surveyQuestions/questionTypes/textBox";
import StarRanking from "../surveyQuestions/questionTypes/starRanking";
import useModalDisplay from "../../../../shared/components/hooks/useModalDisplay/useModalDisplay";

const ArchiveQuestions = (props) => {
  const {
    allArchivedQuestions,
    reActivateArchivedQuestion,
    getArchiveQuestionsByBrandId,
  } = props;

  const {
    register,
    formState: { errors },
  } = useForm();

  const { brandId } = useParams();

  const [archivedQuestions, setArchivedQuestions] = useState([]);
  const [showModal, modalElement, setComponent, closeModal] = useModalDisplay();

  // Show loading while a request is running.
  const spinner = useSpinner();

  //Show confirmation modal when user click on archive modal
  const confirmArchiveQuestion = (brandId, questionId) => {
    setComponent(
      archiveQuestionConfirmationModal({
        onClose: closeModal,
        onConfirm: () =>
          handleAsyncAction(
            reActivateArchivedQuestion(brandId, questionId),
            { onSuccess: closeModal },
          ),
        message:
          "Would you like to reactivate this question? Once confirmed, the reactivated question will reappear on the survey form.",
      })
    );
  };

  useEffect(() => {
    setArchivedQuestions(allArchivedQuestions || []);
  }, [allArchivedQuestions]);

  useEffect(() => {
    getArchiveQuestionsByBrandId(brandId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const GetArchivedQuestionsJsx = () => {
    if (archivedQuestions?.length > 0) {
      return archivedQuestions.map((question, index) => (
        <span key={question?.id || question?.guid}>
          {question.questionTypeId ===
            questionTypeConstants.STAR_RANKING_ID && (
            <StarRanking
              errors={errors}
              index={index + 1}
              question={question}
              register={register}
              confirmReactivateArchiveQuestion={confirmArchiveQuestion}
            />
          )}
          {question.questionTypeId === questionTypeConstants.TEXTBOX_ID && (
            <TextBox
              errors={errors}
              index={index + 1}
              question={question}
              register={register}
              confirmReactivateArchiveQuestion={confirmArchiveQuestion}
            />
          )}
        </span>
      ));
    }
    return [
      <span key="no-questions">
        <h4 className="text-center p-5">No Archived Questions Found</h4>
      </span>,
    ];
  };

  return (
    <>
      {/*Modal here */}
      {showModal && modalElement}
      <div className="container-fluid pb-3">
        {spinner(archivedQuestionsConstants.GET_ARCHIVED_QUESTIONS) ||
        spinner(archivedQuestionsConstants.REACTIVATE_QUESTION) ? (
          <Spinner />
        ) : (
          GetArchivedQuestionsJsx()
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  allArchivedQuestions: state.archivedQuestionsReducer.allArchivedQuestions,
});

const mapDispatchToProps = (dispatch) => ({
  getArchiveQuestionsByBrandId: (brandId) =>
    dispatch(archivedQuestionsActions.getArchiveQuestionsByBrandId(brandId)),
  reActivateArchivedQuestion: (brandId, questionId) =>
    dispatch(
      archivedQuestionsActions.reActivateArchivedQuestion(brandId, questionId),
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(memo(ArchiveQuestions));
